import { ParticipantRowItem } from 'pages/Participants/model/participant'
import * as yup from 'yup'
import { getValidationResult } from 'shared/utils/tools'
import { NoteTypeWithStatus } from 'shared/components/Notes/models/note'
import { TypedSession } from 'pages/ProgramsEvents/model/session'

export const PAGENAME = 'CHECKIN-LIST-PAGE'
export const checkInExportSchema = yup.object().shape({
  end_date: yup
    .string()
    .label('End date')
    .required(),
  start_date: yup
    .string()
    .label('Start date')
    .required(),
})
export type CheckInExportType = yup.InferType<typeof checkInExportSchema>
export function getEmptyExportFilter() {
  return {
    end_date: '',
    start_date: '',
  }
}

export function checkInExportValidator(data: CheckInExportType) {
  return getValidationResult(data, checkInExportSchema)
}

export type CheckinRowItem = ParticipantRowItem & {
  checkin_time: string
  check_out_time: string
  participant_id?: string
  programs_and_events?: TypedSession[]
  notes?: {
    count: number
    data: NoteTypeWithStatus[]
  }
  flags?: {
    count: number
    data: NoteTypeWithStatus[]
  }
}
